// removed by extract-text-webpack-plugin
module.exports = {"main":"GridRow-main--eVNYE","titleContainer":"GridRow-titleContainer--ixN5f","childrenContainer":"GridRow-childrenContainer--2tnFi","title":"GridRow-title--xZdkg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/GridRow/GridRow.scss
// module id = RhGX
// module chunks = 4